var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecuritingOffer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.522,
    height: 19.221,
    viewBox: "0 0 38.522 19.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_69882",
    "data-name": "Raggruppa 69882",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37462",
    "data-name": "Tracciato 37462",
    d: "M37.118,18.1a1.727,1.727,0,0,1-1.88,1.1q-13.949-.021-27.9-.008H6.83L3.277.011H32.3a1.566,1.566,0,0,1,1.781,1.216,1.222,1.222,0,0,1,.012.157q.945,5.162,1.909,10.32.518,2.8,1.037,5.6a2.122,2.122,0,0,0,.08.258Zm-16.8-7.157h7.293a4.18,4.18,0,0,0,.655-.045,1.371,1.371,0,0,0,1.183-1.115c.125-.894-.583-1.526-1.728-1.526H12.9a3.246,3.246,0,0,0-.578.048,1.334,1.334,0,0,0-1.158,1.533,1.539,1.539,0,0,0,1.7,1.1q3.722.006,7.446,0Z",
    transform: "translate(1.398 0)",
    fill: "#37bb90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37463",
    "data-name": "Tracciato 37463",
    d: "M0,17.1c.176-.767.364-1.532.527-2.3Q1.575,9.873,2.61,4.947l.766-3.585a.5.5,0,0,1,.156-.289L7.271,18.736H6.677c-1.493,0-2.987-.025-4.478.008a2.02,2.02,0,0,1-2.2-1.1Z",
    transform: "translate(0 0.458)",
    fill: "#37bb90"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecuritingOffer);
export default __webpack_public_path__ + "static/media/recuritingOffer.d2b673361bd471d0ba028fce16932a6d.svg";
export { ForwardRef as ReactComponent };